export default __webpack_public_path__ + "static/media/image@3x.52bfed97.png";